








import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    advertisingSpace: {
        supplier: string,
    };
}

@Component({ components: { SimpleText } })
export default class Supplier extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.advertisingSpace.supplier",
        ];
    }
}
